import { Phone } from "lucide-react";
import { SITE } from "../data/site";

export default function FloatingCallButton() {
  return (
    <a
      data-testid="floating-call-now-btn"
      href={`tel:${SITE.phoneDigits}`}
      aria-label={`Call ${SITE.phone}`}
      className="floating-call"
    >
      <Phone className="h-5 w-5" />
      <span className="hidden sm:inline">Call Now</span>
      <span className="hidden md:inline opacity-80">· {SITE.phone}</span>
    </a>
  );
}
